// Mock data for Kristy Russo, Realtor — RE/MAX Corridor
// NOTE: All data here is mocked for the frontend preview.

export const agent = {
  name: "Kristy Russo",
  logo: "/logo.png",
  title: "Realtor® · RE/MAX Corridor",
  tagline: "Putting Heroes into Homes",
  subtagline:
    "Casual-luxury real estate service across the Texas Hill Country — specializing in VA loans and buyers who've been told \"no\" before.",
  phone: "210-274-3556",
  phoneHref: "tel:2102743556",
  email: "Kristy.russo@remax.net",
  emailHref: "mailto:Kristy.russo@remax.net",
  brokerage: "RE/MAX Corridor",
  location: "Schertz · Cibolo · New Braunfels · Greater San Antonio, TX",
  photo:
    "/kristy-headshot.jpg",
  photoAlt:
    "https://images.unsplash.com/photo-1770199105692-9e52ff137cad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxmZW1hbGUlMjByZWFsdG9yfGVufDB8fHx8MTc4NzYxODM5NHww&ixlib=rb-4.1.0&q=85",
};

export const images = {
  heroExteriors: [
    "/hero-sold.jpg",
    "https://images.unsplash.com/photo-1505843513577-22bb7d21e455?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob21lJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzg3NjE4Mzk0fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1591474200742-8e512e6f98f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBob21lJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzg3NjE4Mzk0fDA&ixlib=rb-4.1.0&q=85",
  ],
  interiors: [
    "https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob21lJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3NjE4Mzk0fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob21lJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3NjE4Mzk0fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob21lJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3NjE4Mzk0fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1562438668-bcf0ca6578f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBob21lJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg3NjE4Mzk0fDA&ixlib=rb-4.1.0&q=85",
  ],
  veteranFamily: [
    "https://images.pexels.com/photos/7984365/pexels-photo-7984365.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/7984351/pexels-photo-7984351.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1785471722707-7231b1effb8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHx2ZXRlcmFuJTIwZmFtaWx5JTIwaG9tZXxlbnwwfHx8fDE3ODc2MTgzOTR8MA&ixlib=rb-4.1.0&q=85",
  ],
};

export const vaCredentials = {
  name: "Kristy Russo",
  title: "VA Loan Specialist & Top-Producing Realtor®",
  ribbon: "Top 1% Producer • Multiple #1 Rankings",
  paragraphs: [
    "As a multiple-time TOP ranked agent at my brokerage, I've helped many veterans, active-duty service members, and military families secure their dream homes using the VA home loan benefit — with zero down, zero PMI, and zero stress.",
    "With deep expertise in VA loan protocols, entitlement restoration, PCS moves, and funding fee strategies, I don't just close deals — I protect your benefits and maximize your savings.",
  ],
  achievements: [
    "Closing VA loans with zero lender fall-through",
    "Expert in partial entitlement, IRRRL, and cash-out refinances",
    "Ranked Top in brokerage sales multiple times",
    "Proud supporter of local veteran organizations",
    "Full-service from pre-approval to keys — you're never on your own",
  ],
  closing: "Serving Texas Veterans with Honor, Integrity, and Proven Results.",
};

export const lender = {
  name: "Sharon Campbell",
  title: "Senior Loan Officer · Veteran Mortgage One",
  blurb:
    "Sharon is my go-to lending partner and the reason I can say \"yes\" so often. She specializes in VA loans and works with genuinely flexible guidelines — including no minimum credit score on many VA loans.",
  applyUrl:
    "https://txbestvaloancom.floify.com?utm_source=kristyrusso&utm_medium=website&utm_campaign=va_referral&ref=kristyrusso",
  perks: [
    "VA loan specialist",
    "Flexible credit guidelines",
    "Fast, secure online application",
    "Referred & trusted by Kristy",
  ],
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Loan Types", path: "/loan-types" },
  { label: "Credit Challenges", path: "/credit-challenges" },
  { label: "Apply To Buy", path: "/apply-to-buy" },
  { label: "About Me", path: "/about-me" },
  { label: "Sellers", path: "/sellers" },
  { label: "New to Texas?", path: "/new-to-texas" },
];

export const stats = [
  { value: "$0", label: "Down Payment on VA Loans" },
  { value: "No Min.", label: "Credit Score Required*" },
  { value: "300+", label: "Families Guided Home" },
  { value: "Top 1%", label: "Corridor Sales & Listings" },
];

export const propertySearch = [
  { city: "Schertz", url: "https://www.zillow.com/schertz-tx/" },
  { city: "Cibolo", url: "https://www.zillow.com/cibolo-tx/" },
  { city: "New Braunfels", url: "https://www.zillow.com/new-braunfels-tx/" },
  { city: "Selma", url: "https://www.zillow.com/selma-tx/" },
  { city: "Universal City", url: "https://www.zillow.com/universal-city-tx/" },
  { city: "Garden Ridge", url: "https://www.zillow.com/garden-ridge-tx/" },
  { city: "San Antonio", url: "https://www.zillow.com/san-antonio-tx/" },
  { city: "Seguin", url: "https://www.zillow.com/seguin-tx/" },
];

export const loanTypes = [
  {
    name: "VA Loans",
    highlight: true,
    tagline: "My specialty — earned by service.",
    perks: [
      "$0 down payment for qualified veterans",
      "No minimum credit score with my flexible lender",
      "No private mortgage insurance (PMI)",
      "Competitive, capped interest rates",
    ],
    description:
      "If you've served, you've earned one of the most powerful loan programs in America. I walk you through eligibility, your Certificate of Eligibility, and pair you with a lender who says yes when others say no.",
  },
  {
    name: "FHA Loans",
    badge: "Scores as Low as 500!",
    tagline: "Buy with a credit score as low as 500.",
    perks: [
      "Credit scores as low as 500 accepted*",
      "As little as 3.5% down (580+)",
      "Flexible, forgiving credit guidelines",
      "Gift funds allowed for down payment",
    ],
    description:
      "FHA is one of the most forgiving loans in America — with my flexible lender, buyers with credit scores as low as 500 can qualify. It's a powerful first step into homeownership while you rebuild.",
  },
  {
    name: "Conventional Loans",
    tagline: "Classic financing with room to grow.",
    perks: [
      "Down payments from 3%–20%",
      "No upfront funding fee",
      "PMI drops off at 20% equity",
      "Ideal for strong credit profiles",
    ],
    description:
      "The most common loan in America. If your credit is strong, conventional financing offers flexibility and long-term savings.",
  },
  {
    name: "USDA Loans",
    tagline: "Country living, zero down.",
    perks: [
      "$0 down in eligible rural areas",
      "Low mortgage insurance",
      "Great rates for the Hill Country",
      "Income-based eligibility",
    ],
    description:
      "Much of the Texas Corridor qualifies for USDA financing — a beautiful way to buy with no money down outside city limits.",
  },
];

export const creditChallenges = {
  intro:
    "Been turned down before? Take a breath. A single \"no\" is not the end of your story — it's just the start of ours.",
  bullets: [
    {
      title: "No Minimum Credit Score on VA Loans*",
      body: "My lender partner is genuinely flexible. Where big banks see a number, we see your full picture — service, income, and potential.",
    },
    {
      title: "Recovering from Bankruptcy or Foreclosure",
      body: "There are seasoning timelines that make buying possible sooner than you'd think. I'll map the exact date you become eligible.",
    },
    {
      title: "Collections, Charge-offs & Late Payments",
      body: "We build a simple, honest game plan — sometimes you don't even need to pay everything off to close.",
    },
    {
      title: "Self-Employed or Non-Traditional Income",
      body: "Gig work, 1099, cash tips, new business — we have loan products designed for real, modern income.",
    },
  ],
  steps: [
    { n: "01", title: "Judgment-Free Call", body: "We talk through where you are today — no shame, no lectures." },
    { n: "02", title: "The Real Picture", body: "I connect you with my flexible lender for a soft, no-impact review." },
    { n: "03", title: "Your Custom Path", body: "You get a clear timeline and the exact steps to a 'yes'." },
    { n: "04", title: "Keys in Hand", body: "We find the home, negotiate hard, and get you to closing." },
  ],
};

export const sellerServices = [
  {
    title: "Casual-Luxury Marketing",
    body: "Magazine-quality photography, cinematic video, and a listing that feels as premium as your home deserves.",
  },
  {
    title: "Pricing That Wins",
    body: "Data-driven pricing strategy backed by real Corridor market analytics — priced to attract and to net you more.",
  },
  {
    title: "Wide-Reach Exposure",
    body: "Your home syndicated across the MLS, RE/MAX's global network, and targeted social campaigns.",
  },
  {
    title: "Skilled Negotiation",
    body: "As a top-ranking listing agent, I protect your equity and negotiate every dollar in your favor.",
  },
];

export const sellerStats = [
  { value: "Top 1%", label: "Listing Agent in the Corridor" },
  { value: "12 Days", label: "Average Time on Market" },
  { value: "99.2%", label: "List-to-Sale Price Ratio" },
];

export const newToTexas = {
  intro:
    "Welcome to the Texas Hill Country — where the tea is sweet, the sunsets are wide, and your dollar stretches further.",
  areas: [
    {
      name: "Schertz",
      blurb: "Family-friendly with top-rated schools, easy access to Randolph AFB and JBSA.",
      img: 0,
    },
    {
      name: "Cibolo",
      blurb: "One of the fastest-growing small towns in America — new builds and big value.",
      img: 1,
    },
    {
      name: "New Braunfels",
      blurb: "Rivers, breweries, and German heritage. The Corridor's crown jewel for lifestyle.",
      img: 2,
    },
    {
      name: "Universal City",
      blurb: "Convenient, established, and beloved by military families near Randolph.",
      img: 3,
    },
  ],
  perks: [
    "No state income tax in Texas",
    "Strong job market around JBSA & San Antonio",
    "Lower cost of living than most of the U.S.",
    "Warm weather and legendary hospitality",
  ],
};

export const testimonials = [
  {
    name: "Marcus & Dana T.",
    role: "U.S. Army Veteran · Cibolo",
    quote:
      "Two lenders told us no because of our credit. Kristy connected us with hers and we closed with $0 down. She truly puts heroes into homes.",
    rating: 5,
  },
  {
    name: "Sofia R.",
    role: "First-Time Buyer · Schertz",
    quote:
      "I thought a past bankruptcy meant I'd rent forever. Kristy gave me an exact plan and a date. We beat it by two months.",
    rating: 5,
  },
  {
    name: "The Alvarez Family",
    role: "Relocated from California",
    quote:
      "Moving to Texas felt overwhelming until Kristy walked us through everything. Casual, warm, and incredibly sharp on negotiation.",
    rating: 5,
  },
];

export const faqs = [
  {
    q: "Do I really need no minimum credit score for a VA loan?",
    a: "My lender partner does not impose a minimum credit score on VA loans in many cases — hence 'No Minimum Credit Score for VA Loans.' Every situation is reviewed individually, so let's talk about yours.",
  },
  {
    q: "I was denied before. Should I bother trying again?",
    a: "Absolutely. Lenders have very different overlays. A 'no' from a big bank is often a 'yes' with the right flexible lender — that's exactly my specialty.",
  },
  {
    q: "How much are your services as a buyer?",
    a: "In most transactions, buyer representation is paid through the sale — meaning my expertise typically costs you nothing out of pocket. Let's confirm the details for your situation.",
  },
  {
    q: "Do you only work with veterans?",
    a: "Not at all. VA and credit-challenged buyers are my specialty, but I proudly serve first-time buyers, sellers, and relocating families all across the Corridor.",
  },
];
